module.exports = __webpack_public_path__ + "img/slide5_img5.902a3807.png";